// ============================================================================
// FNE-BRIDGE Frontend - Constantes unités de mesure (partagées)
// ============================================================================

export const UNITES = [
  // --- Quantité / Commerce ---
  { value: 'pcs', label: 'Pièce(s)' },
  { value: 'unit', label: 'Unité(s)' },
  { value: 'paire', label: 'Paire(s)' },
  { value: 'dz', label: 'Douzaine(s)' },
  { value: 'lot', label: 'Lot(s)' },
  { value: 'pack', label: 'Pack(s)' },
  { value: 'jeu', label: 'Jeu(x)' },
  { value: 'kit', label: 'Kit(s)' },
  { value: 'ensemble', label: 'Ensemble(s)' },
  // --- Poids / Masse ---
  { value: 'g', label: 'Gramme(s)' },
  { value: 'kg', label: 'Kilogramme(s)' },
  { value: 't', label: 'Tonne(s)' },
  // --- Volume / Liquides ---
  { value: 'ml', label: 'Millilitre(s)' },
  { value: 'cl', label: 'Centilitre(s)' },
  { value: 'l', label: 'Litre(s)' },
  // --- Longueur ---
  { value: 'mm', label: 'Millimètre(s)' },
  { value: 'cm', label: 'Centimètre(s)' },
  { value: 'm', label: 'Mètre(s)' },
  { value: 'km', label: 'Kilomètre(s)' },
  // --- Surface ---
  { value: 'm2', label: 'Mètre carré(s)' },
  { value: 'ha', label: 'Hectare(s)' },
  // --- Volume / Capacité ---
  { value: 'm3', label: 'Mètre cube(s)' },
  // --- Temps / Services ---
  { value: 'min', label: 'Minute(s)' },
  { value: 'h', label: 'Heure(s)' },
  { value: 'j', label: 'Jour(s)' },
  { value: 'sem', label: 'Semaine(s)' },
  { value: 'mois', label: 'Mois' },
  { value: 'an', label: 'An(s)' },
  // --- Prestation / Forfait ---
  { value: 'forfait', label: 'Forfait' },
  { value: 'prestation', label: 'Prestation(s)' },
  { value: 'séance', label: 'Séance(s)' },
  { value: 'intervention', label: 'Intervention(s)' },
  { value: 'abonnement', label: 'Abonnement(s)' },
  { value: 'licence', label: 'Licence(s)' },
  // --- Conditionnement ---
  { value: 'boîte', label: 'Boîte(s)' },
  { value: 'carton', label: 'Carton(s)' },
  { value: 'palette', label: 'Palette(s)' },
  { value: 'sac', label: 'Sac(s)' },
  { value: 'bidon', label: 'Bidon(s)' },
  { value: 'fût', label: 'Fût(s)' },
  { value: 'bouteille', label: 'Bouteille(s)' },
  { value: 'rouleau', label: 'Rouleau(x)' },
  { value: 'bobine', label: 'Bobine(s)' },
  { value: 'sachet', label: 'Sachet(s)' },
  { value: 'bac', label: 'Bac(s)' },
  { value: 'conteneur', label: 'Conteneur(s)' },
  // --- Construction / BTP ---
  { value: 'mlin', label: 'Mètre linéaire' },
  { value: 'plaque', label: 'Plaque(s)' },
  { value: 'barre', label: 'Barre(s)' },
  { value: 'feuille', label: 'Feuille(s)' },
  // --- Énergie ---
  { value: 'kwh', label: 'Kilowattheure(s)' },
  // --- Informatique ---
  { value: 'go', label: 'Gigaoctet(s)' },
  { value: 'to', label: 'Téraoctet(s)' },
  // --- Transport ---
  { value: 'voyage', label: 'Voyage(s)' },
  { value: 'trajet', label: 'Trajet(s)' },
  // --- Agriculture ---
  { value: 'régime', label: 'Régime(s)' },
  { value: 'colis', label: 'Colis' },
  { value: 'tas', label: 'Tas' },
] as const;

export const UNITE_DEFAULT = 'pcs';

/** Lookup label from value */
export const getUniteLabel = (value: string): string => {
  const found = UNITES.find((u) => u.value === value);
  return found ? found.label : value;
};
